<template>
    <b-link class="custom pb-2"
            v-if="checkIfVisible()"
            :title="$t('usuń')"
            @click.prevent="deleteElement(itemId)">
        <span class="icon icon-delete"></span>
    </b-link>
</template>

<script>
import EventBus from '@/event-bus'
import { checkUserPermissions } from '@/config/AppConfig'

export default {
  props: ['returnParam', 'itemId', 'permissionParam', 'itemTitle'],
  methods: {
    deleteElement (id) {
      EventBus.$emit(`SHOW_CONFIRM_DELETE_MODAL`, this.returnParam, id, this.itemTitle)
    },
    checkIfVisible () {
      if (this.permissionParam !== undefined && this.permissionParam !== null) {
        return checkUserPermissions(this.permissionParam)
      }
      return true
    }
  }
}
</script>
